import React, { useEffect, useState, useMemo } from "react";
import useApi from "../../utility/Hooks/Api/useApi";
import { PartSpecificationsApi } from "../../services/Api/PartSpecificationsApi";
import FunctionalTableHeader from "../../components/Tables/Headers/FunctionalTableHeader";
import DefaultTable from "../../components/Tables/Bodies/DefaultTable";

export default function PartSpecificationsView() {
    const [specificationsError, setSpecificationsError] = useState("");
    const [q, setQ] = useState("");
    const [searchParam] = useState([
        "partType",
        "status",
    ]);

    const { request: specificationsRequest, data: specificationsData } = useApi();

    const column = [
        { heading: 'Part', value: 'partType', },
        { heading: 'Details', value: 'details', },
        { heading: 'Status', value: 'status', },
        // { heading: 'Details', value: 'details', },
    ];

    useEffect(() => {
        specificationsRequest(PartSpecificationsApi.getPartSpecifications())
    }, []);

    const searchHandler = (items) => {
        return items?.filter((item) => {
            return searchParam.some((newItem) => {
                if (newItem.includes(".")) {
                    const itemSplit = newItem.split(".");
                    return (
                        item[itemSplit[0]][itemSplit[1]]
                            ?.toString()
                            ?.toLowerCase()
                            ?.indexOf(q.toLowerCase()) > -1
                    );
                } else {
                    return (
                        item[newItem]
                            ?.toString()
                            ?.toLowerCase()
                            ?.indexOf(q.toLowerCase()) > -1
                    );
                }
            });
        });
    };

    const currentTableData = useMemo(() => {
        return searchHandler(specificationsData)
    }, [specificationsData, q]);

    return (
        <>
            <div className="relative container mx-auto shadow-2xl bg-white rounded-lg min-h-[46.4rem]">
                {specificationsError && <p>Error: {specificationsError}</p>}
                {specificationsData ? (
                    <>
                        <FunctionalTableHeader
                            title={"Part Specifications"}
                            // onClick={deletionCondition ? () => deleteModalHandler() : null}
                            onClickAdd={() => null}
                            // onDelete={deletionCondition}
                            // onClickEdit={() => editModalHandler()}
                            onChange={(e) => setQ(e.target.value)} />
                        <DefaultTable
                            data={currentTableData}
                            column={column}
                            // onChange={(e) => deletionHandler(e)} 
                            // deletionItems={checkItems}
                            // onNavDetail="/main/part/"
                            // checkBox
                            pageType="partSpecifications" />
                    </>
                ) : (
                    <p>Loading specifications...</p>
                )}
            </div>
        </>
    );
}

// Fetching specifications without custom hook {useApi}
// Change configurations => specifications
// const [configurations, setConfigurations] = useState([]);

// const fetchConfigurations = useCallback(async () => {
//     try {
//         const response = await PartSpecificationsApi.getPartSpecifications();
//         setConfigurations(response.data)
//     } catch (error) {
//         setConfigurationsError(error)
//     }
// }, []);

// useEffect(() => {
//     fetchConfigurations();
// }, [fetchConfigurations])